/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../common/currency';
import '../banklin/transaction';
import './model';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bizbank": {
        "nested": {
          "unified_activity": {
            "nested": {
              "UnifiedActivity": {
                "fields": {
                  "activityToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "latestEventAt": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "activityType": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "activityState": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivity.ActivityState",
                    "id": 4,
                    "rule": "optional"
                  },
                  "description": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": "squareup.common.Money",
                    "id": 6,
                    "rule": "optional"
                  },
                  "balance": {
                    "type": "squareup.common.Money",
                    "id": 7,
                    "rule": "optional"
                  },
                  "merchantImage": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage",
                    "id": 8,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  },
                  "unitToken": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "declineReason": {
                    "type": "string",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cardLastFour": {
                    "type": "string",
                    "id": 12,
                    "rule": "optional"
                  },
                  "transactionReasonCode": {
                    "type": "squareup.banklin.TransactionReasonCode",
                    "id": 13,
                    "rule": "optional"
                  },
                  "merchantCanonicalCategory": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory",
                    "id": 14,
                    "rule": "optional"
                  },
                  "banklinCardToken": {
                    "type": "string",
                    "id": 15,
                    "rule": "optional"
                  },
                  "balanceToken": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ActivityType": {
                    "values": {
                      "UNKNOWN": 0,
                      "CARD_PAYMENT": 1,
                      "ATM_WITHDRAWAL": 2,
                      "DEBIT_CARD_TRANSFER_IN": 3,
                      "STANDARD_TRANSFER_OUT": 4,
                      "INSTANT_TRANSFER_OUT": 5,
                      "CARD_PROCESSING_SALES": 6,
                      "CARD_PROCESSING_ADJUSTMENTS": 7,
                      "PROMOTIONAL_REWARD": 8,
                      "PAYROLL": 9,
                      "PAYROLL_CANCELLATION": 10,
                      "DIRECT_DEPOSIT_IN": 11,
                      "DIRECT_DEPOSIT_OUT": 12,
                      "CAPITAL_LOAN": 13,
                      "CAPITAL_LOAN_CANCELLATION": 14,
                      "CHECK_TRANSFER_IN": 15,
                      "BALANCE_TRANSFER_SFS_AND_BANKLIN": 16,
                      "BALANCE_TRANSFER_OTHER": 17,
                      "BALANCE_TRANSFER_IN_SFS_TO_BANKLIN": 18,
                      "BALANCE_TRANSFER_OUT_BANKLIN_TO_SFS": 19,
                      "DEBIT_CARD_PAY_IN_CHARGEBACK": 20,
                      "DIRECT_DEPOSIT_IN_CHARGEBACK": 21,
                      "CHECK_TRANSFER_IN_CHARGEBACK": 22,
                      "BILL_PAYMENT": 23
                    }
                  },
                  "ActivityState": {
                    "values": {
                      "PENDING": 1,
                      "SETTLED": 2,
                      "VOIDED": 3,
                      "DECLINED": 4,
                      "REFUNDED": 5,
                      "REVERSED": 6,
                      "DISPUTED": 7,
                      "DISPUTE_REVERSED": 8,
                      "DISPUTE_WON": 9,
                      "IN_REVIEW": 10,
                      "IN_REVERSAL": 11,
                      "WAITING_ON_EXTERNAL": 12,
                      "INITIATED": 13
                    }
                  },
                  "MerchantImage": {
                    "fields": {
                      "merchantImageUrl": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "colorCode": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "backgroundColorCode": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "isPrerendered": {
                        "type": "bool",
                        "id": 4,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "MerchantCanonicalCategory": {
                    "fields": {
                      "name": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetUnifiedActivitiesRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activityStateCategory": {
                    "type": "squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory",
                    "id": 2,
                    "rule": "optional"
                  },
                  "filters": {
                    "type": "squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters",
                    "id": 3,
                    "rule": "optional"
                  },
                  "batchRequest": {
                    "type": "squareup.bizbank.model.BatchRequest",
                    "id": 4,
                    "rule": "optional"
                  },
                  "currentTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "ActivityStateCategory": {
                    "values": {
                      "PENDING": 1,
                      "COMPLETED": 2
                    }
                  },
                  "Filters": {
                    "fields": {
                      "includeActivityTypes": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity.ActivityType",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "minLatestEventAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      },
                      "maxLatestEventAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 3,
                        "rule": "optional"
                      },
                      "maxRetroactiveBalanceVersion": {
                        "type": "int64",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetUnifiedActivitiesResponse": {
                "fields": {
                  "response": {
                    "type": "squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "unifiedActivities": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "paginationToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "hasHiddenBalanceActivityTransactions": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["response", "errorMessage"]
                  }
                }
              },
              "UnifiedActivityDetails": {
                "fields": {
                  "description": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "modifiers": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "grossAmount": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "netAmount": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "externalLink": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink",
                    "id": 6,
                    "rule": "optional"
                  },
                  "attachments": {
                    "type": "squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment",
                    "id": 7,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Modifier": {
                    "fields": {
                      "modifierType": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType",
                        "id": 1,
                        "rule": "optional"
                      },
                      "modifierAmount": {
                        "type": "squareup.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "modifierAmountDescription": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "ModifierType": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "COMMUNITY_REWARD": 1,
                          "ATM_WITHDRAWAL_FEE": 2,
                          "INSTANT_TRANSFER_FEE": 3,
                          "CASHBACK": 4,
                          "CARD_PAYMENT_FEE": 5,
                          "GENERIC_REWARD": 6
                        }
                      }
                    }
                  },
                  "ExternalLink": {
                    "fields": {
                      "title": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "url": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Attachment": {
                    "fields": {
                      "localizedLabel": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "imageData": {
                        "type": "bytes",
                        "id": 2
                      }
                    },
                    "nested": {
                      "content": {
                        "oneof": ["imageData"]
                      }
                    }
                  }
                }
              },
              "GetUnifiedActivityDetailsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "activityToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "currentTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetUnifiedActivityDetailsResponse": {
                "fields": {
                  "response": {
                    "type": "squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "Response": {
                    "fields": {
                      "unifiedActivity": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivity",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unifiedActivityDetails": {
                        "type": "squareup.bizbank.unified_activity.UnifiedActivityDetails",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "result": {
                    "oneof": ["response", "errorMessage"]
                  }
                }
              },
              "LineItem": {
                "fields": {
                  "type": {
                    "type": "squareup.bizbank.unified_activity.LineItem.LineItemType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "total": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "LineItemType": {
                    "values": {
                      "UNKNOWN": 0,
                      "PROCESSING_CARD_PAYMENTS": 1,
                      "PROCESSING_CARD_REFUNDS": 2,
                      "PROCESSING_CARD_TOTAL_COLLECTED": 3,
                      "PROCESSING_CARD_FEES": 4,
                      "PROCESSING_FREE_PROCESSING_CREDIT": 5,
                      "PROCESSING_SQUARE_CAPITAL_REPAYMENT": 6,
                      "PROCESSING_DISPUTES": 7,
                      "PROCESSING_RESERVES_HELD": 8,
                      "PROCESSING_RESERVES_RELEASED": 9,
                      "PROCESSING_OTHER_ADJUSTMENTS": 10,
                      "TRANSFERS_OUT": 11,
                      "TRANSFERS_INSTANT_FEES": 12,
                      "TRANSFERS_IN": 13,
                      "TRANSFERS_BANK_ACCOUNT_DEBITS": 14,
                      "PROCESSING_SAVINGS_TRANSFER": 15,
                      "CARD_PAYMENT": 16,
                      "ATM_WITHDRAWAL": 17,
                      "PROMOTIONAL_REWARD": 18
                    }
                  }
                }
              },
              "TopLevelLineItem": {
                "fields": {
                  "type": {
                    "type": "squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "total": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "subLineItems": {
                    "type": "squareup.bizbank.unified_activity.LineItem",
                    "id": 3,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "TopLevelLineItemType": {
                    "values": {
                      "UNKNOWN": 0,
                      "PAYMENT_PROCESSING": 1,
                      "SQUARE_CARD_SPEND": 2,
                      "TRANSFERS": 3,
                      "PAYROLL": 4,
                      "LOANS": 5
                    }
                  }
                }
              },
              "BalanceOverview": {
                "fields": {
                  "startingBalance": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endingBalance": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lineItems": {
                    "type": "squareup.bizbank.unified_activity.TopLevelLineItem",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "GetBalanceOverviewRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  },
                  "maxRetroactiveBalanceVersion": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "GetBalanceOverviewResponse": {
                "fields": {
                  "balanceOverview": {
                    "type": "squareup.bizbank.unified_activity.BalanceOverview",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["balanceOverview", "errorMessage"]
                  }
                }
              },
              "PaymentProcessingDetails": {
                "fields": {
                  "lineItems": {
                    "type": "squareup.bizbank.unified_activity.LineItem",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "GetPaymentProcessingDetailsRequest": {
                "fields": {
                  "unitToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "squareup.common.time.DateTime",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "GetPaymentProcessingDetailsResponse": {
                "fields": {
                  "paymentProcessingDetails": {
                    "type": "squareup.bizbank.unified_activity.PaymentProcessingDetails",
                    "id": 1
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2
                  }
                },
                "nested": {
                  "result": {
                    "oneof": ["paymentProcessingDetails", "errorMessage"]
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityType && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.ActivityState && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantImage && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivity?.nested?.MerchantCanonicalCategory && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.ActivityStateCategory && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesRequest?.nested?.Filters && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivitiesResponse?.nested?.Response && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Modifier?.nested?.ModifierType && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.ExternalLink && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.UnifiedActivityDetails?.nested?.Attachment && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetUnifiedActivityDetailsResponse?.nested?.Response && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.LineItem?.nested?.LineItemType && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.TopLevelLineItem?.nested?.TopLevelLineItemType && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.BalanceOverview && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetBalanceOverviewResponse && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.PaymentProcessingDetails && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsRequest && !$root.nested?.squareup?.nested?.bizbank?.nested?.unified_activity?.nested?.GetPaymentProcessingDetailsResponse) {
  $root.addJSON(jsonData);
}

/**
 * These protos are used in clients directly (not translated to client-protos).
 * Sync with clients to confirm changes.
 * Activity that may affect a seller's balance.
 *
 * SOURCE UnifiedActivity @ squareup/bizbank/unified_activity.proto at 21:1
 */
export const UnifiedActivity = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity');
fixType(UnifiedActivity, {
  activityToken: {
    required: true
  },
  latestEventAt: {
    required: true
  },
  activityType: {
    required: true
  },
  activityState: {
    required: true
  },
  description: {
    required: true
  },
  amount: {
    required: true
  },
  balanceToken: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(UnifiedActivity);
/**
 * SOURCE ActivityType @ squareup/bizbank/unified_activity.proto at 22:3
 */
UnifiedActivity.ActivityType = $root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityType').values;
/**
 * Currently maps to com.squareup.protos.banklin.data.TransactionState
 *
 * SOURCE ActivityState @ squareup/bizbank/unified_activity.proto at 73:3
 */
UnifiedActivity.ActivityState = $root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivity.ActivityState').values;
/**
 * SOURCE MerchantImage @ squareup/bizbank/unified_activity.proto at 130:3
 */
UnifiedActivity.MerchantImage = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantImage');
fixType(UnifiedActivity.MerchantImage, {
  merchantImageUrl: {
    required: true
  }
});
Builder.createAndAttachToType(UnifiedActivity.MerchantImage);
/**
 * SOURCE MerchantCanonicalCategory @ squareup/bizbank/unified_activity.proto at 140:3
 */
UnifiedActivity.MerchantCanonicalCategory = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivity.MerchantCanonicalCategory');
fixType(UnifiedActivity.MerchantCanonicalCategory, {
  name: {
    required: true
  }
});
Builder.createAndAttachToType(UnifiedActivity.MerchantCanonicalCategory);
/**
 * SOURCE GetUnifiedActivitiesRequest @ squareup/bizbank/unified_activity.proto at 219:1
 */
export const GetUnifiedActivitiesRequest = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest');
fixType(GetUnifiedActivitiesRequest, {
  activityStateCategory: {
    required: true
  }
});
Builder.createAndAttachToType(GetUnifiedActivitiesRequest);
/**
 * Category of UnifiedActivity.ActivityStates
 *
 * SOURCE ActivityStateCategory @ squareup/bizbank/unified_activity.proto at 221:3
 */
GetUnifiedActivitiesRequest.ActivityStateCategory = $root.lookupEnum('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.ActivityStateCategory').values;
/**
 * SOURCE Filters @ squareup/bizbank/unified_activity.proto at 227:3
 */
GetUnifiedActivitiesRequest.Filters = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesRequest.Filters');
fixType(GetUnifiedActivitiesRequest.Filters);
Builder.createAndAttachToType(GetUnifiedActivitiesRequest.Filters);
/**
 * SOURCE GetUnifiedActivitiesResponse @ squareup/bizbank/unified_activity.proto at 252:1
 */
export const GetUnifiedActivitiesResponse = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse');
fixType(GetUnifiedActivitiesResponse);
Builder.createAndAttachToType(GetUnifiedActivitiesResponse);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 253:3
 */
GetUnifiedActivitiesResponse.Response = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivitiesResponse.Response');
fixType(GetUnifiedActivitiesResponse.Response);
Builder.createAndAttachToType(GetUnifiedActivitiesResponse.Response);
/**
 * SOURCE UnifiedActivityDetails @ squareup/bizbank/unified_activity.proto at 271:1
 */
export const UnifiedActivityDetails = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails');
fixType(UnifiedActivityDetails, {
  description: {
    required: true
  },
  grossAmount: {
    required: true
  },
  netAmount: {
    required: true
  }
});
Builder.createAndAttachToType(UnifiedActivityDetails);
/**
 * SOURCE Modifier @ squareup/bizbank/unified_activity.proto at 272:3
 */
UnifiedActivityDetails.Modifier = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier');
fixType(UnifiedActivityDetails.Modifier, {
  modifierType: {
    required: true
  },
  modifierAmount: {
    required: true
  }
});
Builder.createAndAttachToType(UnifiedActivityDetails.Modifier);
/**
 * SOURCE ModifierType @ squareup/bizbank/unified_activity.proto at 273:5
 */
UnifiedActivityDetails.Modifier.ModifierType = $root.lookupEnum('squareup.bizbank.unified_activity.UnifiedActivityDetails.Modifier.ModifierType').values;
/**
 * Associated URL for an activity
 *
 * SOURCE ExternalLink @ squareup/bizbank/unified_activity.proto at 290:3
 */
UnifiedActivityDetails.ExternalLink = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.ExternalLink');
fixType(UnifiedActivityDetails.ExternalLink);
Builder.createAndAttachToType(UnifiedActivityDetails.ExternalLink);
/**
 * SOURCE Attachment @ squareup/bizbank/unified_activity.proto at 296:3
 */
UnifiedActivityDetails.Attachment = $root.lookupType('squareup.bizbank.unified_activity.UnifiedActivityDetails.Attachment');
fixType(UnifiedActivityDetails.Attachment);
Builder.createAndAttachToType(UnifiedActivityDetails.Attachment);
/**
 * SOURCE GetUnifiedActivityDetailsRequest @ squareup/bizbank/unified_activity.proto at 321:1
 */
export const GetUnifiedActivityDetailsRequest = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsRequest');
fixType(GetUnifiedActivityDetailsRequest, {
  activityToken: {
    required: true
  }
});
Builder.createAndAttachToType(GetUnifiedActivityDetailsRequest);
/**
 * SOURCE GetUnifiedActivityDetailsResponse @ squareup/bizbank/unified_activity.proto at 330:1
 */
export const GetUnifiedActivityDetailsResponse = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse');
fixType(GetUnifiedActivityDetailsResponse);
Builder.createAndAttachToType(GetUnifiedActivityDetailsResponse);
/**
 * SOURCE Response @ squareup/bizbank/unified_activity.proto at 331:3
 */
GetUnifiedActivityDetailsResponse.Response = $root.lookupType('squareup.bizbank.unified_activity.GetUnifiedActivityDetailsResponse.Response');
fixType(GetUnifiedActivityDetailsResponse.Response, {
  unifiedActivity: {
    required: true
  },
  unifiedActivityDetails: {
    required: true
  }
});
Builder.createAndAttachToType(GetUnifiedActivityDetailsResponse.Response);
/**
 * A single row
 *
 * SOURCE LineItem @ squareup/bizbank/unified_activity.proto at 396:1
 */
export const LineItem = $root.lookupType('squareup.bizbank.unified_activity.LineItem');
fixType(LineItem);
Builder.createAndAttachToType(LineItem);
/**
 * SOURCE LineItemType @ squareup/bizbank/unified_activity.proto at 397:3
 */
LineItem.LineItemType = $root.lookupEnum('squareup.bizbank.unified_activity.LineItem.LineItemType').values;
/**
 * A single row that is expandable with sub items
 *
 * SOURCE TopLevelLineItem @ squareup/bizbank/unified_activity.proto at 442:1
 */
export const TopLevelLineItem = $root.lookupType('squareup.bizbank.unified_activity.TopLevelLineItem');
fixType(TopLevelLineItem);
Builder.createAndAttachToType(TopLevelLineItem);
/**
 * SOURCE TopLevelLineItemType @ squareup/bizbank/unified_activity.proto at 443:3
 */
TopLevelLineItem.TopLevelLineItemType = $root.lookupEnum('squareup.bizbank.unified_activity.TopLevelLineItem.TopLevelLineItemType').values;
/**
 * SOURCE BalanceOverview @ squareup/bizbank/unified_activity.proto at 462:1
 */
export const BalanceOverview = $root.lookupType('squareup.bizbank.unified_activity.BalanceOverview');
fixType(BalanceOverview);
Builder.createAndAttachToType(BalanceOverview);
/**
 * SOURCE GetBalanceOverviewRequest @ squareup/bizbank/unified_activity.proto at 468:1
 */
export const GetBalanceOverviewRequest = $root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewRequest');
fixType(GetBalanceOverviewRequest);
Builder.createAndAttachToType(GetBalanceOverviewRequest);
/**
 * SOURCE GetBalanceOverviewResponse @ squareup/bizbank/unified_activity.proto at 476:1
 */
export const GetBalanceOverviewResponse = $root.lookupType('squareup.bizbank.unified_activity.GetBalanceOverviewResponse');
fixType(GetBalanceOverviewResponse);
Builder.createAndAttachToType(GetBalanceOverviewResponse);
/**
 * SOURCE PaymentProcessingDetails @ squareup/bizbank/unified_activity.proto at 483:1
 */
export const PaymentProcessingDetails = $root.lookupType('squareup.bizbank.unified_activity.PaymentProcessingDetails');
fixType(PaymentProcessingDetails);
Builder.createAndAttachToType(PaymentProcessingDetails);
/**
 * SOURCE GetPaymentProcessingDetailsRequest @ squareup/bizbank/unified_activity.proto at 487:1
 */
export const GetPaymentProcessingDetailsRequest = $root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsRequest');
fixType(GetPaymentProcessingDetailsRequest);
Builder.createAndAttachToType(GetPaymentProcessingDetailsRequest);
/**
 * SOURCE GetPaymentProcessingDetailsResponse @ squareup/bizbank/unified_activity.proto at 493:1
 */
export const GetPaymentProcessingDetailsResponse = $root.lookupType('squareup.bizbank.unified_activity.GetPaymentProcessingDetailsResponse');
fixType(GetPaymentProcessingDetailsResponse);
Builder.createAndAttachToType(GetPaymentProcessingDetailsResponse);